import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * Sticky bottom-right floating CTA visible on landing & investing pages.
 * Hidden on /onboard, /success, /admin/*.
 */
export default function FloatingApplyCTA() {
  const location = useLocation();
  const hide =
    location.pathname.startsWith("/onboard") ||
    location.pathname.startsWith("/success") ||
    location.pathname.startsWith("/admin");

  if (hide) return null;

  return (
    <Link
      to="/onboard"
      data-testid="floating-apply-cta"
      className="hidden sm:inline-flex fixed bottom-6 right-6 z-40 btn-primary items-center gap-2 px-5 py-3 text-sm tracking-wide rounded-none shadow-[0_10px_30px_-10px_rgba(192,48,40,0.45)]"
    >
      Apply now
      <ArrowRight size={14} />
    </Link>
  );
}
